import PropTypes from 'prop-types';

export default function Tile({ tile_content }) {
	const { name, image, desc, link, link_type, link_text } = { ...tile_content };

	return (
		<a href={link} target="_blank" rel="noreferrer" title={link_text} className="tile tile--image-size-regular" data-link-type={link_type}>
			<div className="tile__container">
				<header className="tile__header">
					{image && <img src={image} alt={name} />}
					<p className="h6">{name}</p>
				</header>
				<div className="tile__content">
					<p>{desc}</p>
				</div>
				<footer className="tile__footer"></footer>
			</div>
		</a>
	);
}

Tile.propTypes = {
	tile_content: PropTypes.object,
};
